import { supabase } from './supabase';

export async function fetchPublishedMembers() {
  const { data, error } = await supabase
    .from('members')
    .select('*')
    .eq('is_published', true)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return data;
}

export async function fetchAllMembers() {
  const { data, error } = await supabase
    .from('members')
    .select('*')
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return data;
}

export async function fetchMemberById(id) {
  const { data, error } = await supabase.from('members').select('*').eq('id', id).single();
  if (error) throw error;
  return data;
}

export async function upsertMember(member) {
  const { data, error } = await supabase.from('members').upsert(member).select().single();
  if (error) throw error;
  return data;
}

export async function deleteMember(id) {
  const { error } = await supabase.from('members').delete().eq('id', id);
  if (error) throw error;
}

export async function getNextMemberSortOrder() {
  const { data, error } = await supabase
    .from('members')
    .select('sort_order')
    .order('sort_order', { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return (data?.sort_order ?? 0) + 1;
}
